import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const pageRoutes = ({
    Search,
    Create,
    Update,

}: {
    Search: React.ComponentType;
    Create: React.ComponentType;
    Update: React.ComponentType;
}) => (
    <Routes>
        <Route path={''} element={<Search />} />
        <Route path={ROUTES.PERMISSION.PAGE.CREATE} element={<Create />} />
        <Route path={ROUTES.PERMISSION.PAGE.EDIT} element={<Update />} />
    </Routes>
);
